import { useFormikContext } from 'formik';
import React from 'react';
import { CopyButton } from '@components/common/CopyButton';
import { SideSummary } from '@components/common/SideSummary';
import { PriceString } from '@fourthwall/components';
import { TimezonedDateString } from '../../../../../../../Timezone/components/TimezonedDateString';
import { useCurrentShop } from '../../../../../../hooks/useCurrentShop';
import { isGiftCardGroup } from '../../utils/isGiftCardGroup';
import { isGiftCardSingle } from '../../utils/isGiftCardSingle';
import * as S from './GiftCardSummary.styled';
export const GiftCardSummary = ({ giftCard }) => {
    const { values, errors } = useFormikContext();
    const { currentShopQuery } = useCurrentShop();
    const renderSummaryContent = () => {
        if (((values.type === 'SINGLE' && !values.code) ||
            (values.type === 'MULTIPLE' && !values.codes?.length)) &&
            (!values.amount || errors.amount)) {
            return React.createElement(React.Fragment, null, "Enter information on the left to see a summary of your gift card here.");
        }
        return (React.createElement(React.Fragment, null,
            values.type === 'SINGLE' && values.code && (React.createElement(SideSummary.Item, { title: "Code to use at checkout:" },
                React.createElement(S.GiftCardCodeWrapper, null,
                    values.code,
                    giftCard && isGiftCardSingle(giftCard) && (React.createElement(CopyButton, { copyText: giftCard.code, iconSize: 16 }))))),
            values.type === 'MULTIPLE' && (React.createElement(SideSummary.Item, { title: "Number of gift card codes:" },
                values.codes.length,
                ' ',
                giftCard && isGiftCardGroup(giftCard) && (React.createElement(React.Fragment, null,
                    "(",
                    giftCard.giftCards.filter(({ status }) => status === 'FULLY_USED').length,
                    " used)")))),
            values.amount && !errors.amount && (React.createElement(SideSummary.Item, { title: "Gift card value:" },
                React.createElement(PriceString, { value: values.amount, currency: currentShopQuery?.data?.settings.currency }),
                giftCard && isGiftCardSingle(giftCard) && (React.createElement(React.Fragment, null,
                    ' ',
                    "(used ",
                    React.createElement(PriceString, { ...giftCard.balance.used }),
                    ")")))),
            React.createElement(SideSummary.Item, { title: "Expiration date:" },
                (values.expirationDateType === 'NONE' || !values.expirationDate) && (React.createElement(React.Fragment, null, "No expiration date")),
                values.expirationDateType === 'REQUIRED' && values.expirationDate && (React.createElement(TimezonedDateString, { date: values.expirationDate, format: "h:mm A, MMM d, YYYY", withTimezoneAbbreviation: false })))));
    };
    return React.createElement(SideSummary, null, renderSummaryContent());
};
